/**
 * Restricción temporal de eliminaciones de alto impacto en Firebase.
 * Desactivar poniendo HIGH_IMPACT_DELETIONS_DISABLED = false cuando el backend esté reforzado.
 */
export const HIGH_IMPACT_DELETIONS_DISABLED = true

const BASE_MESSAGE =
  'La eliminación está temporalmente deshabilitada por seguridad mientras se refuerzan los controles del backend.'

export const isHighImpactDeletionBlocked = () => HIGH_IMPACT_DELETIONS_DISABLED

/**
 * @param {string} [context] - Contexto legible (ej. "eliminar pedido")
 * @returns {{ success: false, error: string }}
 */
export const getHighImpactDeletionBlock = (context = '') => ({
  success: false,
  error: context ? `${BASE_MESSAGE} Operación: ${context}.` : BASE_MESSAGE,
})
